import React from 'react';
import { Toggle } from '@core/js/components/common/Fields/Toggle';
import { useComponentTranslations } from '@core/js/hooks/component';
import { clsx } from '@core/js/utils/classNames.util';

import * as Types from '@theme/js/components/popups/CookiesRegulationPopup/types';

import style from './CookieSettingsToggle.scss';

export const CookieSettingsToggle: React.FC<Types.ICookieSettingsToggleProps> = ({
    cookieKey,
    data,
    onToggleChange,
    isSystem = false,
    isDisabled = false
}) => {
    const translate = useComponentTranslations();

    const isChecked = isSystem || data[cookieKey];
    const isToggleDisabled = isSystem || isDisabled;

    return (
        <div key={cookieKey} className={style.toggleContainer}>
            <div className={style.toggleAccordion}>
                <Toggle
                    name={cookieKey}
                    checked={isChecked}
                    disabled={isToggleDisabled}
                    className={style.toggle}
                    classNames={{
                        toggleMark: style.toggleMark,
                        input: style.toggleInput,
                        label: clsx([
                            style.toggleLabel,
                            isSystem && style.systemToggleLabel
                        ])
                    }}
                    onChange={onToggleChange}
                    label={translate(`name.${cookieKey}`)}
                />
            </div>
            <div className={clsx([
                style.description,
                isSystem && style.systemDescription
            ])}>
                {translate(`description.${cookieKey}`)}
            </div>
        </div>
    );
};
